import {
  Box,
  Grid,
  Stack,
  Theme,
  Typography,
  hexToRgb,
  useTheme,
} from "@mui/material";
import BgImage from "@/assets/images/magic/magic_new_banner.png";
import {
  UseCssMediaQuery,
  useCssMediaQuery,
} from "@/shared/base/hooks/useCssMediaQuery";
import { TeamConfig, useTeamConfig } from "@/global/hooks/useTeamConfig";
import FindGamesBanner from "public/images/magic/magic_ChooseYourGamesBanner_cropped.jpeg";
import NextImage from "next/image";
import { blurDataURL } from "@/global/common/blur-data-url";

interface Props {
  title?: string;
}

export function BrandedCallout(props: Props) {
  const theme = useTheme();
  const screenSize = useCssMediaQuery("down");
  const { md: mdDown } = screenSize;
  const teamConfig = useTeamConfig();
  const { images, browserTitle, uiConfigs } = teamConfig;
  const { isBackgroundBasedBanner } = uiConfigs.bannerImage;
  const fallbackHeight = "148px";
  const imageSrc =
    mdDown && images?.mobileFindGamesBannerImage
      ? images?.mobileFindGamesBannerImage
      : images.findGamesBannerImage;

  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: mdDown ? "6px" : "8px",
        position: "relative",
        width: "100%",
        display: "flex",
        overflow: "hidden",
        alignItems: "center",
        height: isBackgroundBasedBanner ? fallbackHeight : "unset",
      }}
    >
      <NextImage
        src={imageSrc}
        alt={`${browserTitle}`}
        width={1486}
        height={148}
        style={{
          width: "100%",
          height: isBackgroundBasedBanner ? "100%" : "auto",
          objectFit: "cover",
        }}
        loading="lazy"
        placeholder="blur"
        blurDataURL={blurDataURL}
      />

      {isBackgroundBasedBanner ? (
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            container
            alignItems={"center"}
            position={"relative"}
            zIndex={1}
            width={"100%"}
            spacing={mdDown ? 2 : 1}
            px={isBackgroundBasedBanner ? (mdDown ? 3 : 4) : 0}
            py={isBackgroundBasedBanner ? (mdDown ? 3 : 5) : 0}
          >
            <Grid item xs={12} lg={8}>
              {props?.title ? (
                <Box>
                  <Typography
                    variant="h4"
                    fontWeight={800}
                    color={theme.palette.common.white}
                  >
                    {props.title}
                  </Typography>
                </Box>
              ) : null}
            </Grid>
          </Grid>
        </Box>
      ) : null}
    </Box>
  );
}
